import moment from "moment";
import { find , filter, forEach, get, set } from "lodash";
import { caseLessComparision,isNumberOrNumberString } from "@utils/helpers";
import { CONTAINS, EQUALS, IS_MANDATORY, NOT_EQUALS } from "@utils/constants";
import { notification } from "antd";
export interface taskValidation {
  length: {
    maxLength: number | undefined;
    message: string;
  };
  inputType : (x:any) => {inputTypeFunc : ((input: string) => string) , inputType_message : string};
  disabledDateFunc: (x:any) => boolean | undefined;
}

interface InputTypeValidation {
  id : number;
  name: string;
  message : string;
}

export const getMaxLengthOfInput = (lengthValidation : any) => {
    if(lengthValidation) {
        return {maxLength : lengthValidation.name.split('-')[1] ?? undefined , message : lengthValidation.message};
    }
}; 

export const getInputType : any = (inputTypeValidation : InputTypeValidation) => {

  let inputTypeFunc = (input : string) => input;

  let message = '';

    if(inputTypeValidation) {
        message = inputTypeValidation.message;
        const inputType  = inputTypeValidation.name.split('_')[1];
        if(inputType === 'alphanumeric') {
          inputTypeFunc =  (input : string) => input.replace(/[^a-z0-9]/gi, '')
        } else if(inputType === 'string') {
          inputTypeFunc = (input : string) => input.replace(/[^a-zA-Z]/g, '')
        } else if(inputType === 'number'){
          inputTypeFunc = (input : string) => input.replace(/\D/g, '')
        }
    }

    return {inputTypeFunc , message }
}

export const disabledDateFunc = (currentDate: any, dateValidations: any = [] , subtasks : any= [] , additionalDetails : any = {} , additionalData : any = {}) => {
  const pastDateValidation = find(dateValidations || [], (validation: any) => {
    return validation.name.includes("date_past") || (validation.name.includes("date_max") && !validation.name.includes("subtask"));
  })?.name?.toLowerCase();

  const futureDateValidation = find(dateValidations || [], (validation: any) => {
    return validation.name.includes("date_future")  || (validation.name.includes("date_min") && !validation.name.includes("subtask"));
  })?.name?.toLowerCase();

  const dependentValidation = find(dateValidations || [], (validation : any) => {
    return validation.name.includes("subtask");
  })?.name?.toLowerCase();

  let result = true; 

  if (pastDateValidation) {
    const arr = pastDateValidation.split('-');
    if(isNumberOrNumberString(arr[1]) && ['days' , 'months' , 'years'].includes(arr[2])){
        const prevDate = moment().subtract(arr[1], arr[2]);
        result = result && (currentDate && currentDate.format('YYYY-MM-DD HH:mm:ss') > prevDate.format('YYYY-MM-DD HH:mm:ss') && currentDate.format('YYYY-MM-DD HH:mm:ss') <= moment().format('YYYY-MM-DD HH:mm:ss'));
    } else {
      // result = result && currentDate && currentDate.format('YYYY-MM-DD HH:mm:ss') <= moment().format('YYYY-MM-DD HH:mm:ss')
      if(subtasks.length > 0) {
        result = result && currentDate && currentDate.isSameOrBefore(moment().utc(true));
      } else {
        result = result && currentDate && currentDate.isSameOrBefore(moment());
      } 
    } 
  } 

  if(futureDateValidation) {
    const arr = futureDateValidation.split('-');
    if(isNumberOrNumberString(arr[1]) && ['days' , 'months' , 'years'].includes(arr[2])){
        const futureDate = moment().add(arr[1], arr[2]);
        result = result && (currentDate && currentDate.format('YYYY-MM-DD HH:mm:ss') < futureDate.format('YYYY-MM-DD HH:mm:ss') && currentDate.format('YYYY-MM-DD HH:mm:ss') >= moment().format('YYYY-MM-DD HH:mm:ss'));
    } else {
      // result = result && currentDate && currentDate.format('YYYY-MM-DD HH:mm:ss') >= moment().format('YYYY-MM-DD HH:mm:ss')}
      if(subtasks.length > 0) {
        result = result && currentDate && currentDate.isSameOrAfter(moment().utc(true));
      } else {
        result = result && currentDate && currentDate.isSameOrAfter(moment());
      } 
    }
  } 

  if(dependentValidation) {
    if(dependentValidation.includes('date_min-subtask')) {
      const arr = dependentValidation.split('|');
      const depenDentSubtaskTempId = arr[1];
      let dependentValue ;
      if(subtasks.length > 0) {
        dependentValue = subtasks.find((a : any) => a.subtaskTempId === depenDentSubtaskTempId)?.value
        result = result && currentDate.isSameOrAfter(moment(dependentValue).utc());
      } else {
        dependentValue = additionalData[depenDentSubtaskTempId];
        result = result && currentDate.isSameOrAfter(moment(dependentValue));
      }
    }
  }
  return !result;
};

export const getValidations : any = (taskValidations: any , activeTask : any , additionalDetails : any, additionalData : any) => {
  const subtasks = activeTask?.subtasks;

  const textValidations = filter(taskValidations || [], (validation: any) => {
    return validation.name.includes("text");
  });

  const dateValidations = filter(taskValidations || [], (validation: any) => {
    return validation.name.includes("date");
  });

  const multiSelectDropdownValidations = filter(taskValidations || [], (validation: any) => {
    return validation.name.includes("mseldrpdwn");
  });

  const defaultOutput : any = {length : {maxLength : undefined , message : ''} , inputType : {inputTypeFunc : undefined , message : ''} , disabledDateFunc : undefined}

  if (textValidations?.length > 0) {
    return {
      ...defaultOutput,
      length: getMaxLengthOfInput(
        find(textValidations || [], (validation: any) => {
          return validation.name.includes("len");
        })
      ),
      inputType: getInputType(
        find(textValidations || [], (validation: any) => {
          return validation.name.includes("text_alphanumeric") || validation.name.includes("text_string") || validation.name.includes("text_number");
        })
      ),
    };
  } else if (dateValidations.length > 0) {
    return {
      ...defaultOutput,
      disabledDateFunc: (currentDate: any) => disabledDateFunc(currentDate, dateValidations , subtasks , additionalDetails, additionalData),
      validationFunc : (subtask: any) => {
        return subtask.value ? !disabledDateFunc(moment(subtask.value), dateValidations,  subtasks) : true;
      },
    };
  } else if (multiSelectDropdownValidations?.length > 0) {
    const minValidation = multiSelectDropdownValidations.find((validation) => get(validation, "name", "").includes("min"));
    const minValidationCount = minValidation ? get(minValidation , 'name' , '').split("-")[1]  : undefined;

    return {
      ...defaultOutput,
      validationFunc : (subtask: any) => {
        const value = get(subtask,'value','');
        return value.split("$|").length >= minValidationCount;
      },
    };
  } else {
    return {};
  }
};

const hideChildrenSubTasks = (subtaskId: number, dependentSubtasks: { id: number; display: boolean; parent: number; rule: string }[], subtaskDetails: any , activeTask : any) => {
  let child = find(dependentSubtasks, { parent: subtaskId });
  while (child) {
    if (child.id === subtaskId) {
      notification.error({
        message: "Error",
        description: "Technical error, please check template configuration",
      });
      console.log(`%c subtask ${subtaskDetails.description} of subtask Id : ${subtaskId} children are configured incorrectly`, "color: orange; font-weight: bold;font-size: 18px;");
      break;
    } else {
      child.display = false;
      const tempSubtask = find(activeTask.subtasks, { id: child.id });
      set(tempSubtask, "value", null);
      child = find(dependentSubtasks, { parent: child.id });
    }
  }
};

//mapRules function is used to map the rules for the active task and update the _dependantSubTasks 
export const mapRules = (rule: any, activeSubTask: any, _dependantSubTasks: any , activeTask : any) => {
  if (rule?.length > 0 && rule[0]?.operation === EQUALS) {
    forEach(activeSubTask?.ruleName, (item: any) => {
      const temp_rule = find(rule, { ruleName: item?.name });
      if (caseLessComparision(temp_rule?.value, activeSubTask?.value)) {
        forEach(item?.children, (populated_dependent_tasks: any) => {
          const searched_depSubTask = find(_dependantSubTasks, { id: parseInt(populated_dependent_tasks) });
          if (searched_depSubTask) {
            const disPlayRule = find(temp_rule?.properties, { property: "display" });
            if (disPlayRule) {
              searched_depSubTask.display = disPlayRule?.value;
            }
            //the below code is for when a parent subtask has both mandatory rule and display rule for same child subtask
            if (get(temp_rule, "properties[0].property") === IS_MANDATORY) {
              const tempSubtask = find(activeTask.subtasks, { id: parseInt(populated_dependent_tasks) });
              set(tempSubtask, "isMandatory", searched_depSubTask.display && caseLessComparision(temp_rule.value, activeSubTask.value) ? "Y" : "N");
            }
          } else {
            if (get(temp_rule, "properties[0].property") === IS_MANDATORY) {
              const tempSubtask = find(activeTask.subtasks, { id: parseInt(populated_dependent_tasks) });
              if (caseLessComparision(temp_rule.value, activeSubTask.value)) {
                set(tempSubtask, "isMandatory", "Y");
              }
            }
          }
        });
      } else {
        forEach(item?.children, (populated_dependent_tasks: any) => {
          const searched_depSubTask = find(_dependantSubTasks, { id: parseInt(populated_dependent_tasks) });
          if (searched_depSubTask) {
            const tempSubtask = find(activeTask.subtasks, { id: parseInt(populated_dependent_tasks) });
            set(tempSubtask, "value", null);
            const disPlayRule = find(temp_rule?.properties, { property: "display" });
            if (disPlayRule) {
              searched_depSubTask.display = !disPlayRule?.value;
            }
            //the below code is for when a parent subtask has both mandatory rule and display rule for same child subtask
            if (get(temp_rule, "properties[0].property") === IS_MANDATORY) {
              set(tempSubtask, "isMandatory", searched_depSubTask.display && caseLessComparision(temp_rule.value, activeSubTask.value, NOT_EQUALS) ? "Y" : "N");
            }
            hideChildrenSubTasks(searched_depSubTask.id, _dependantSubTasks, tempSubtask , activeTask);
          } else {
            if (get(temp_rule, "properties[0].property") === IS_MANDATORY) {
              if (caseLessComparision(temp_rule?.value, activeSubTask?.value, NOT_EQUALS)) {
                const tempSubtask = find(activeTask.subtasks, { id: parseInt(populated_dependent_tasks) });
                set(tempSubtask, "isMandatory", "N");
              }
            }
          }
        });
      }
    });
  }

  if (rule?.length > 0 && rule[0]?.operation === NOT_EQUALS) {
    forEach(activeSubTask?.ruleName, (item: any) => {
      const temp_rule = find(rule, { ruleName: item?.name });
      if (activeSubTask?.value !== "" && activeSubTask?.value !== null) {
        forEach(item?.children, (populated_dependent_tasks: any) => {
          const searched_depSubTask = find(_dependantSubTasks, { id: parseInt(populated_dependent_tasks) });
          if (searched_depSubTask) {
            const disPlayRule = find(temp_rule?.properties, { property: "display" });
            if (disPlayRule) {
              searched_depSubTask.display = disPlayRule?.value;
            }
            //the below code is for when a parent subtask has both mandatory rule and display rule for same child subtask
            if (get(temp_rule, "properties[0].property") === IS_MANDATORY) {
              const tempSubtask = find(activeTask.subtasks, { id: parseInt(populated_dependent_tasks) });
              set(tempSubtask, "isMandatory", searched_depSubTask.display && caseLessComparision(temp_rule.value, activeSubTask.value) ? "Y" : "N");
            }
          } else {
            if (get(temp_rule, "properties[0].property") === IS_MANDATORY) {
              const tempSubtask = find(activeTask.subtasks, { id: parseInt(populated_dependent_tasks) });
              if (caseLessComparision(temp_rule?.value, activeSubTask?.value)) {
                set(tempSubtask, "isMandatory", "Y");
              }
            }
          }
        });
      } else {
        forEach(item?.children, (populated_dependent_tasks: any) => {
          const searched_depSubTask = find(_dependantSubTasks, { id: parseInt(populated_dependent_tasks) });
          if (searched_depSubTask) {
            const tempSubtask = find(activeTask.subtasks, { id: parseInt(populated_dependent_tasks) });
            set(tempSubtask, "value", null);
            const disPlayRule = find(temp_rule?.properties, { property: "display" });
            if (disPlayRule) {
              searched_depSubTask.display = !disPlayRule?.value;
            }
            //the below code is for when a parent subtask has both mandatory rule and display rule for same child subtask
            if (get(temp_rule, "properties[0].property") === IS_MANDATORY) {
              set(tempSubtask, "isMandatory", searched_depSubTask.display && caseLessComparision(temp_rule.value, activeSubTask.value, NOT_EQUALS) ? "Y" : "N");
            }
            hideChildrenSubTasks(searched_depSubTask.id, _dependantSubTasks, tempSubtask , activeTask);
          } else {
            if (get(temp_rule, "properties[0].property") === IS_MANDATORY) {
              if (caseLessComparision(temp_rule?.value, activeSubTask?.value, NOT_EQUALS)) {
                const tempSubtask = find(activeTask.subtasks, { id: parseInt(populated_dependent_tasks) });
                set(tempSubtask, "isMandatory", "N");
              }
            }
          }
        });
      }
    });
  }

  const _containsRules = filter(rule, { operation: CONTAINS });

  if (_containsRules.length > 0) {
    forEach(activeSubTask?.ruleName, (item: any) => {
      const temp_rule = find(rule, { ruleName: item?.name });
      if (caseLessComparision(temp_rule?.value, activeSubTask.value, EQUALS, CONTAINS)) {
        forEach(item?.children, (populated_dependent_tasks: any) => {
          const searched_depSubTask = find(_dependantSubTasks, { id: parseInt(populated_dependent_tasks) });
          if (searched_depSubTask) {
            const disPlayRule = find(temp_rule?.properties, { property: "display" });
            if (disPlayRule) {
              searched_depSubTask.display = disPlayRule?.value;
            }
            //the below code is for when a parent subtask has both mandatory rule and display rule for same child subtask
            if (get(temp_rule, "properties[0].property") === IS_MANDATORY) {
              const tempSubtask = find(activeTask.subtasks, { id: parseInt(populated_dependent_tasks) });
              set(tempSubtask, "isMandatory", searched_depSubTask.display && caseLessComparision(temp_rule.value, activeSubTask.value, EQUALS, CONTAINS) ? "Y" : "N");
            }
          } else {
            if (get(temp_rule, "properties[0].property") === IS_MANDATORY) {
              const tempSubtask = find(activeTask.subtasks, { id: parseInt(populated_dependent_tasks) });
              if (caseLessComparision(temp_rule?.value, activeSubTask.value, EQUALS, CONTAINS)) {
                set(tempSubtask, "isMandatory", "Y");
              }
            }
          }
        });
      } else {
        forEach(item?.children, (populated_dependent_tasks: any) => {
          const searched_depSubTask = find(_dependantSubTasks, { id: parseInt(populated_dependent_tasks) });
          if (searched_depSubTask) {
            const tempSubtask = find(activeTask.subtasks, { id: parseInt(populated_dependent_tasks) });
            set(tempSubtask, "value", null);
            const disPlayRule = find(temp_rule?.properties, { property: "display" });
            if (disPlayRule) {
              searched_depSubTask.display = !disPlayRule?.value;
            }
            //the below code is for when a parent subtask has both mandatory rule and display rule for same child subtask
            if (get(temp_rule, "properties[0].property") === IS_MANDATORY) {
              set(tempSubtask, "isMandatory", searched_depSubTask.display && caseLessComparision(temp_rule.value, activeSubTask.value, NOT_EQUALS, CONTAINS) ? "Y" : "N");
            }
            hideChildrenSubTasks(searched_depSubTask.id, _dependantSubTasks, tempSubtask , activeTask);
          } else {
            if (get(temp_rule, "properties[0].property") === IS_MANDATORY) {
              if (caseLessComparision(temp_rule?.value, activeSubTask.value, NOT_EQUALS, CONTAINS)) {
                const tempSubtask = find(activeTask.subtasks, { id: parseInt(populated_dependent_tasks) });
                set(tempSubtask, "isMandatory", "N");
              }
            }
          }
        });
      }
    });
  }
};

export const isSubTaskDisplayed = (subtask :any , dependantSubTasks :any ) => {
  const _dependentSt = find(dependantSubTasks , {id : subtask.id});
  // is a subtask is not dependency subtask then it will always be displayed
  if(!_dependentSt){
    return true
  } 
  //if a subtask is dependency subtask based on the rules it will get displayed
  else if(_dependentSt && _dependentSt.display){
    return true
  }

  //if a subtask is dependency subtask but is not getting displayed at present based on rules
  return false;
}

